module.exports = __webpack_public_path__ + "img/cells.bc30d55f.svg";